import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faSignOutAlt,
  faSpinner,
  faSortUp,
  faSortDown,
  faFilter,
  faSearch,
  faTimes,
  faPlusCircle,
  faTrash,
  faDownload,
  faInfoCircle,
  faHome,
  faFileAlt,
  faDollarSign,
  faArchive,
  faBars,
  faChevronLeft,
  faSlidersH,
  faEnvelope,
  faCaretDown,
  faArrowDown,
  faArrowUp,
  faChartBar,
  faChartLine,
  faCog,
  faFileArrowDown,
  faQuestionCircle,
} from '@fortawesome/pro-solid-svg-icons'

const setupIconLibrary = (): void =>
  library.add(
    faSignOutAlt,
    faSpinner,
    faExclamationTriangle,
    faEye,
    faEyeSlash,
    faSortUp,
    faSortDown,
    faFilter,
    faSearch,
    faTimes,
    faPlusCircle,
    faTrash,
    faDownload,
    faInfoCircle,
    faHome,
    faFileAlt,
    faDollarSign,
    faArchive,
    faBars,
    faChevronLeft,
    faSlidersH,
    faEnvelope,
    faCaretDown,
    faArrowDown,
    faArrowUp,
    faChartBar,
    faChartLine,
    faCog,
    faFileArrowDown,
    faQuestionCircle
  )

export default setupIconLibrary
